export default {
  calculate: function (values) {
    if (values.length === 0) return '0,00'
    const total = values.reduce((acumulador, valorAtual) => {
      if (!valorAtual) {
        return acumulador
      }
      const valorNumerico = parseFloat(valorAtual.replaceAll('.', '').replaceAll(',', '.'))
      return acumulador + (isNaN(valorNumerico) ? 0 : valorNumerico)
    }, 0)
    return Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(total)
  }
}
